import { AnyAction } from 'redux';

const SET_HEARTBEAT = 'SET_HEARTBEAT';

export const setHeartbeat = (value: boolean) => ({
    type: SET_HEARTBEAT,
    payload: value,
});

const initialState = {
    startHeartbeat: false,
};

export default function heartbeatReducer(state = initialState, action: AnyAction) {
    if (action.type === SET_HEARTBEAT) {
        return { ...state, startHeartbeat: action.payload };
    }
    return state;
}
